import { Component, OnInit, ViewChild } from "@angular/core";
import { ConfirmationModalService } from "@app/admin/confirmation-modal.service";
import {
  RequestState,
  RequestStateEnum,
} from "@app-module/shared/RequestState";
import { PopupLayoutComponent } from "@app/admin/confirmation-popup/popup-layout/popup-layout.component";
import { Subscription } from "rxjs";
import { UserService } from "@app-service/user.service";
import { DashboardCardsService } from "@app-service/dashboard-cards.service";
import { ToasterService, ToasterType } from "@app-service/toaster.service";

import {
  ENKASH_TENANT_VALUE,
  tenantSetter,
} from "@app-common/http/interceptors/tenantType";
import { CreateErupiPopupComponent } from "./create-erupi-account-popup/create-erupi-popup.component";
import { ErupiGenericContactDetailsComponent } from "./generic-contact-details/erupi-generic-contact-details.component";

@Component({
    selector: "app-erupi-popup",
    templateUrl: "./erupi-popup.component.html",
    styleUrls: ["./erupi-popup.component.scss"],
    standalone: false
})
export class ErupiPopupComponent implements OnInit {
  private subscriptions: Subscription = new Subscription();
  submitRequestState: RequestState;
  @ViewChild("modal") modal: PopupLayoutComponent;

  constructor(
    public userService: UserService,
    private cardsDashboardService: DashboardCardsService,
    private toasterService: ToasterService,
    private confirmationModal: ConfirmationModalService
  ) {
    this.submitRequestState = RequestState.init();
  }

  ngOnInit(): void {}

  onSetup(): void {
    this.confirmationModal.showInformationalModal(CreateErupiPopupComponent, {
      centered: true,
      scrollable: true,
      size: "xl",
    });
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  onRequestDemo(): void {
    tenantSetter(ENKASH_TENANT_VALUE);
    this.submitRequestState.pending();
    this.subscriptions.add(
      this.cardsDashboardService
        .captureInterest("ERUPI_DEMO_REQUEST")
        .subscribe(
          (res) => {
            this.modal.close();
            this.submitRequestState.completed();
            this.confirmationModal.showInformationalModal(
              ErupiGenericContactDetailsComponent,
              {
                centered: true,
                scrollable: true,
                size: "sm",
              }
            );
          },
          (err) => {
            this.submitRequestState.rejected();
            this.toasterService.showToaster(
              err["error"]["payload"]
                ? err["error"]["payload"]
                : "Something went wrong",
              ToasterType.ERROR
            );
          }
        )
    );
  }

  formActionRequestState(): RequestStateEnum {
    return this.submitRequestState.state;
  }
}
